module.exports = __webpack_public_path__ + "img/popup_vip_open_head_short.f2f59554.png";